module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ashou4-dbcb9a04ca07387132c943fcede6280a.jpg";